import React from 'react';
import "../../assets/style/Contact.css"
import Map from './Map';
import Card from './Card';
import Formulaire from './Formulaire';
import {useTranslation} from "react-i18next"


const Contact: React.FC = () => {
  const { t } = useTranslation('fr', { useSuspense: false });
  return (
    <div>
      <section className="contact section" id="contact">
        <div className='contenu'>
        <h2 data-heading="Mes joindre" className="section__title">{t('titleContact')}</h2>
        <div className="contact__container container grid">
          <Card />
          <Formulaire />
          <Map />
        </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;